import { render, staticRenderFns } from "./ProductSubsectionComponent.vue?vue&type=template&id=58f26519&"
import script from "./ProductSubsectionComponent.ts?vue&type=script&lang=ts&"
export * from "./ProductSubsectionComponent.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "ProductSubsectionComponent.vue"
export default component.exports